import api from './api';

export const fetchConfig = async () => {
    try {
        const response = await api.get(`/config`);
        
        return response.data.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;  // Rethrow the error to be handled in the component
    }
};